import { useCallback, useEffect, useState } from 'react';
import { fetchUnits } from '../services/unit.api';

export function useUnits() {
  const [raw, setRaw] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const data = await fetchUnits();
      setRaw(data);
    } catch {
      setRaw([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { raw, loading, reload: load };
}
